export default __webpack_public_path__ + "static/media/REAL CPI ASSET STIKER-17.d33518c0.png";